import React from "react";
import { useGetSoccerMatchesQuery } from "../../store/services/mainApi";
import Loader from "./Loader";
import Error from "./Error";

const SoccerList = () => {
  const { data, isFetching, error } = useGetSoccerMatchesQuery();

  if (isFetching) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  console.log(data);

  return (
    <div>
      {data.map((ele) => {
        return (
          <div className="inner_inplay px-3 py-2  text-sm bg-[#ffff]">
            <span className="text-[#243a48] font-bold">2023-04-05</span>
            <span>
              <a
                href=""
                className="hover:underline text-[#2789ce] font-bold mx-2"
              >
              {ele?.ename}
              </a>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default SoccerList;
